import { HttpClient } from "@angular/common/http";
import {AppDataClientService} from "../client/app-service/app-data-client.service";
import {Injectable} from "@angular/core";

@Injectable()
export class BaseApiService {

  constructor(
    protected http: HttpClient,
    protected dataService: AppDataClientService
  ) {
  }
}
